import { render, staticRenderFns } from "./CardFact.vue?vue&type=template&id=09067db3&"
import script from "./CardFact.vue?vue&type=script&lang=js&"
export * from "./CardFact.vue?vue&type=script&lang=js&"
import style0 from "./CardFact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports